import { FormattedMessage } from 'react-intl';

import { Pane, Text } from '@/modules/ui';

import { ImportForm } from '../ImportForm';
import { ImportLimitReachedModal } from '../ImportLimitReachedModal';
import { ImportProgressModal } from '../ImportProgressModal';
import { ImportValidationModal } from '../ImportValidationModal';
import * as felaRules from './Import.rules';

export const Import = () => (
    <Pane titleId='import.title'>
        <Text customStyle={felaRules.text}>
            <FormattedMessage id='import.message' />
        </Text>
        <ImportForm />
        <ImportValidationModal />
        <ImportProgressModal />
        <ImportLimitReachedModal />
    </Pane>
);
